import { Seo } from "@/components/Seo";
import { site } from "@/config/site";
import { headingText } from "@/lib/heading";

export function TalksPage() {
  return (
    <>
      <Seo
        title="Talks"
        description="Talks and product sessions on YouTube, under my name and ecosystem.Ai."
        path="/talks"
      />
      <section className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Talks</p>
        <h1>Watch on YouTube</h1>
        <p className="lede">
          Talks and product sessions are on YouTube, under my name and ecosystem.Ai.
        </p>
        <div className="grid-2">
          <article className="card">
            <p className="badge">YouTube</p>
            <h2>
              <a href={site.profiles.youtubeJay} rel="noreferrer noopener">
                {headingText("Jay van Zyl")}
              </a>
            </h2>
            <p>Search YouTube for talks and interviews under my name.</p>
          </article>
          <article className="card">
            <p className="badge">YouTube</p>
            <h2>
              <a href={site.profiles.youtubeEcosystem} rel="noreferrer noopener">
                {headingText("ecosystem.Ai")}
              </a>
            </h2>
            <p>Search YouTube for platform sessions and product recordings.</p>
          </article>
        </div>
      </section>
    </>
  );
}
